<form #companyForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/company']">Company</a> > {{ company.company_name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(companyForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company Name</mat-label>
            <input type="text" matInput name="company_name" [(ngModel)]="company.company_name" required #companyName="ngModel">
            <mat-error *ngIf="companyName.invalid && companyName.touched">Company name is required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Email</mat-label>
            <input type="text" matInput name="email_id" [(ngModel)]="company.email_id">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>GST No.</mat-label>
            <input type="text" matInput name="gst_number" [(ngModel)]="company.gst_number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>PAN</mat-label>
            <input type="text" matInput name="pan_number" [(ngModel)]="company.pan_number">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Bank Name and Branch</mat-label>
            <input type="text" matInput name="bank_name_and_branch" [(ngModel)]="company.bank_name_and_branch">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Bank Account No.</mat-label>
            <input type="text" matInput name="bank_acount_number" [(ngModel)]="company.bank_acount_number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>IFSC Code</mat-label>
            <input type="text" matInput name="ifsc_code" [(ngModel)]="company.ifsc_code">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Cheque in Favour of</mat-label>
            <input type="text" matInput name="cheque_in_favour_of" [(ngModel)]="company.cheque_in_favour_of">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Contact No.</mat-label>
            <input type="text" matInput name="contact_number" [(ngModel)]="company.contact_number">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>GST (%) for Invoicing</mat-label>
            <input maxlength="2" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" matInput name="gst_percentage" [(ngModel)]="company.gst_percentage">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Address Line 1</mat-label>
            <input type="text" matInput name="address_1" [(ngModel)]="company.address_1">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Address Line 2</mat-label>
            <input type="text" matInput name="address_2" [(ngModel)]="company.address_2">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>City</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedCity" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onCityKey($event)" matInput name="city_list">
              <mat-option *ngFor="let city of filteredCities" [value]="city.id">{{ city.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>State</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedState" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onStateKey($event)" matInput name="state_list">
              <mat-option *ngFor="let state of filteredStates" [value]="state.id">{{ state.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Pincode</mat-label>
            <input type="text" matInput name="pincode" [(ngModel)]="company.pincode">
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="company" [recordId]="company.id"></app-audit-log-viewer>
</form>
